export class Attributetypes {
  static COUNTRY_TYPE = "CRYCD";
  static PAYMENT_TERM_TYPE = "PMTCD";
  static AR_TYPE = "ACRCD";
  static CURRENCY_TYPE = "CURCD";
  static CUSTOMER_TYPE = "CSTCD";
  static FINANCIAL_TYPE = "FINCD";
  static WAREHOUSE_TYPE = "WHCD";
  static SHIP_VIA_TYPE = "SHVCD";
  static INVOICE_TEMPLATE_TYPE = "IVTCD";
  static PAYMENT_METHOD_TYPE = "PMMCD";
  static COMMISSION_TYPE_TYPE = "CMMTCD";
  static VENDOR_SHIP_VIA_TYPE = "VSHCD";
  static VENDOR_TERM_TYPE = "VNTCD";
  static FOB_CITY_TERM_TYPE = "FOBCTYCD";
  static SHIPMENT_TERM_TYPE = "SHPPMTCD";
  static VENDOR_CATEGORY_TYPE = "VNDCATCD";
  static INCO_TERM_TYPE = "INCOTRMTCD";
  static CITY_TYPE = "CTYCD";
  static STATE_TYPE = "STECD";
  static UOM_TYPE = "UOMTCD";
  static SALES_PERSON_TYPE = "SPCD";
  static ACCOUNT_REPRESENTATIVE_TYPE = "ARPCD";
  static PRODUCT_TYPE_TYPE = "PRTCD";
  static SEASON_TYPE = "SEACD";
  static PRODUCT_SUB_TYPE_TYPE = "PRSTCD";
  static PRODUCT_MODEL_TYPE = "PRMOTCD";
  static PRODUCT_PLATING_TYPE = "PRPTCD";
  static PRODUCT_STONE_COLOR_TYPE = "PRSCTCD";
  static PRODUCT_METAL_TYPE = "PRMTCD";
  static PRODUCT_COUNTRY_OF_ORIGIN_TYPE = "PRCOOTCD";
  static CUSTOMER_DIVISION_TYPE = "CDNCD";
  static CUSTOMER_DEPARTMENT_TYPE = "CDPCD";
  static CUSTOMER_CLASS_TYPE = "CCLCD";
  static CUSTOMER_SUB_CLASS_TYPE = "CSCCD";
  static CUSTOMER_SALES_ZONE_TYPE = "ZNCD";
  static CUSTOMER_SALES_REGION_TYPE = "RGNCD";
  static CUSTOMER_SALES_DISTRICT_TYPE = "DSTCD";
  static CUSTOMER_SALES_TERRITORY_TYPE = "TRYCD";
  static PRODUCT_DIVISION_TYPE = "PDNCD";
  static PRODUCT_DEPARTMENT_TYPE = "PDPCD";
  static PRODUCT_CLASS_TYPE = "PCLCD";
  static PRODUCT_SUB_CLASS_TYPE = "PSCCD";
  static CURRENCY_EXCHANGE_RATE_TYPE = "CURERTCD";
  static PATTERN_TYPE_TYPE = "PRTCD";
  static MAKE_TYPE_TYPE = "MKTCD";
  static SPECIAL_TYPE = "SPTCD";
  static COMPOSITION_TYPE = "CPTCD";
  static ROYALTY_CLIENT_TYPE = "RCTCD";
  static COLOR_TYPE = "CLRTCD";
  static SALES_ORDER_TYPE = "SOTCD";
  static SALES_ORDER_CANCEL_REASON_TYPE = "SOCRTCD";
  static SALES_ORDER_UN_APPROVAL_REASON_TYPE = "SOUNAPPTCD";
  static INVENTORY_ADJUSTMENT_REASON_TYPE = "IARTCD";
  static DOCUMENT_TYPE_TYPE = "DOTCD";
  static PURCHASE_ORDER_CANCEL_REASON_TYPE = "POCNTCD";
  static PURCHASE_ORDER_EXTRA_CHARGE_REASON_TYPE = "POEXCHTCD";
  static PURCHASE_ORDER_UN_APPROVAL_REASON_TYPE = "POUNAPPTCD";
  static PURCHASE_ORDER_RECEIPT_CANCEL_REASON_TYPE = "PRCNTCD";
  static PURCHASE_ORDER_RECEIPT_BAD_QUALITY_REASON_TYPE = "PRBQRTCD";
  static PURCHASE_ORDER_RECEIPT_UN_APPROVAL_REASON_TYPE = "PRUNAPPTCD";
  static EXTRA_CHARGE_REASON_TYPE = "ECRTCD";
  static INVOICE_PRINT_TYPE_TYPE = "INVPT";
  static INVOICE_CANCEL_REASON_TYPE = "ICRCD";
  static INVOICE_NON_MERCHANDISE_REASON_TYPE = "INVNOMRCD";
  static INVOICE_UN_APPROVAL_REASON_TYPE = "IUNAPPTCD";
  static INVOICE_TYPE_TYPE = "INTCD";
  static CREDIT_MEMO_TYPE_TYPE = "CRTCD";
  static CREDIT_MEMO_SUB_TYPE_TYPE = "CRSTCD";
  static CREDIT_REASON_TYPE = "CRRCD";
  static AR_DISCOUNT_DETAIL_REASON_TYPE = "ARDRCD";
  static VENDOR_INVOICE_CANCEL_REASON_TYPE = "INCTCD";
  static VENDOR_INVOICE_UNAPPROVAL_REASON_TYPE = "INUTCD";
  static EXPENSE_TYPE_TYPE = "EXTCD";
  static VENDOR_INVOICE_MISCELLANEOUS_REASON_TYPE = "INMTCD";
  static GENERAL_LEDGER_ACCOUNTTYPE_TYPE = "GLACTTCD";
  static GENERAL_LEDGER_ACCOUNT_TYPE = "GLACCTCD";
  static MISCELLANEOUS_CHARGE_REASON_TYPE = "MSCRTCD";
  static BANK_ACCOUNT_TYPE = "BATCD";
  static LOCATION_TYPE = "LOCTCD";
  static TRANSACTION_TYPE_TYPE = "TRTCD";
  static VENDOR_TYPE = "VNTCD";
  static FREIGHT_METHOD_TYPE = "FRTCD";
  static CUSTOMER_TENDER_REASON_TYPE = "CTRCD";
  static CUSTOMER_TENDER_CANCEL_REASON_TYPE = "CACTRCD";
  static CUSTOMER_TENDER_UN_APPROVAL_REASON_TYPE = "CTUNAPPRCD";
  static PERIOD_SALES_COMMISSION_ADJUSTMENT_REASON_TYPE = "CACTRCD";
  static BOX_TYPE = "BOXCD";
  static ACCOUNT_RECEIVABLE_REVERSAL_REASON_TYPE = "ARREV";
  static STAGE_TYPE = "STGCD";
  static PRE_PRODUCTION_CHANGE_REASON_TYPE = "PREPROD";
  static PATTERN_TYPE_CATEGORY_TYPE = "PRTCTD";
  static COD_FUNDS_CODE_TYPE = "CODFCD";
  static CUSTOMER_DELIVERY_TYPE = "CDTCD";
  static PURCHASE_ORDER_DATE_CHANGE_REASON_TYPE = "PODTCRCD";
  static PURCHASE_ORDER_INTRANSIT_CANCEL_REASON_TYPE = "POITCNCD";
  static PURCHASE_ORDER_INTRANSIT_UNAPPROVE_REASON_TYPE = "POITUNACD";
  static PURCHASE_ORDER_MODEL = "POMODL";
  static PREPRODUCTION_ORDER_CANCEL_REASON_TYPE = "PPOCRTCD";
  static PREPRODUCTION_ORDER_UNAPPROVE_REASON_TYPE = "PPOURTCD";
  static STYLE_ITEM_TYPE = "SITTY";
  static HARMONIZED_TARIFF_TYPE = "HTSCD";
  static PRODUCT_STATUS = "PSCD";
  static CUSTOMER_SPECIAL_TYPE = "CSSTCD";
  static PURCHASE_ORDER_TYPE = "POTCD";
  static FABRIC_VENODR_MISCELLANEOUS_COST_REASON_TYPE = "FVMCD";
  static EXPENSE_SUB_TYPE = "EXSTCD";
  static DPEOSIT_REVERSE_REASON_TYPE = "DPRNTCD";
  static DEPOSIT_CANCEL_REASON_TYPE = "DPCNTCD";
  static BANK_ADJUSTMENT_REASON_TYPE = "BATCD";
  static FISCAL_YEAR_TYPE = "FYTCD";
  static BUSINESS_DIVISION_TYPE = "BTCD";
  static COMMENT_TYPE = "CCD";
  static SHIP_TO_TYPE = "STCD";
  static BIN_LOCATION_TYPE = "BINTCD";
  static FABRIC_DETAIL_TYPE = "FADTL";
  static WEB_EXPORT_TYPE_TYPE = "WETCD";
  static TAREGET_WEBSITE_TYPE = "TWTCD";
  static SERVICE_TYPE = "STCD";
}
